__webpack_require__.p = "https://decisionmakingservice.prtl.co/dist/";